import React, { useCallback } from 'react';
import Box from '@mui/material/Box';
import { IconButton, Paper, Collapse, Tooltip, Button, useTheme, useMediaQuery } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';
import PlayIcon from '@mui/icons-material/PlayArrow';
import TimeScrubberControls from './TimeScrubberControls';
import TimeLabel from './TimeLabel';

export default function TimeScrubber({
  timeRange,
  currentTime,
  onTimeChange,
  onTimeRangeChange,
  playing,
  setPlaying,
  chart,
  tightToBottom=true,
  defaultExpanded=false,
  children,
  hideDatePicker = true,
}: {
    timeRange: [Date, Date, boolean];
    currentTime: Date | undefined;
    onTimeChange: (newTime: Date | ((prevTime: Date) => Date)) => void;
    onTimeRangeChange: (newRange: [Date, Date, boolean]) => void;
    hideDatePicker?: boolean;
    chart?: ({ expanded }: { expanded: boolean }) => React.ReactNode;
    children?: React.ReactNode;
}) {
  const [fromTime, toTime, live] = timeRange;

  const theme = useTheme()
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'))

  const [legendOpen, setLegendOpen] = React.useState(true);
  const toggleLegend = useCallback(() => setLegendOpen(o => !o), []);
  const legendOpenAuto = legendOpen;// || !currentTime;

  const [expanded_, setExpanded] = React.useState(defaultExpanded === null ? !isSmall : defaultExpanded);
  const expanded = expanded_ && !!currentTime;
  const toggleExpanded = useCallback(() => setExpanded(e => !e), []);

  const onTimeChangePause = useCallback((t) => {
    setPlaying(false);
    onTimeChange(t);
  }, [onTimeChange, setPlaying]);

  return (
    <Box sx={{ 
            // overflow: 'hidden',
            // overflowX: 'hidden',
            // overflowY: 'visible',

            // height: legendOpen ? '50vh' : 'auto',
            // transition: 'height 0.3s ease',
            // // mx: 'auto', 
            position: 'absolute',
            // bottom: expanded ? 0 : { xs: 0, md: 0 },
            bottom: 0,
            left: 0,
            right: 0,
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            zIndex: 10,

            // mx: 0,
            p: 1,
            // mx: { xs: 1, md: 'auto' },
            // mx: { xs: 1, md: 2 },
            mb: tightToBottom ? { xs: 1, md: 1 } : { xs: 4, md: 2 },
            // maxWidth: expanded ? '100%' : 800, 
            pointerEvents: { xs: 'auto', sm: 'none' },
            
            // maxWidth: '100%', 
            // width: expanded ? 'calc(100% - 2px)' : 800,
            transition: 'bottom 0.3s ease, width 0.3s ease, height 0.3s ease',

            '& input[type="datetime-local"]': {
              flexGrow: 1,
              border: '1px solid',
              borderColor: 'divider',
              borderRadius: '4px',
              padding: '4px 8px',
              fontSize: '0.875rem',
              bgcolor: 'background.paper',
            },
        }}>
      <Paper elevation={expanded ? 4 : 6} sx={{ 
        position: 'relative',
        maxWidth: '100%',
        // bgcolor: 'background.bold',
        border: '1px solid white',
        backgroundImage: 'none',
        mx: 'auto', 
        // mx: { xs: 1, md: 'auto' },
        // width: '100%' 
        width: expanded ? 'calc(100% - 2px)' : 800,
        transition: 'bottom 0.3s ease, width 0.3s ease, height 0.3s ease',
        p: 1,
        pointerEvents: 'auto',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        flexWrap: 'wrap', 

        // bgcolor: 'background.paper', 
        borderRadius: '20px',
        // maxWidth: expanded ? '100%' : 800, 
      }}>
      <TimeLabel currentTime={currentTime} timeRange={timeRange} onTimeChange={onTimeChangePause} setTimeRange={onTimeRangeChange} />
      <TimeSliderExpandIconButton expanded={expanded} onClick={toggleExpanded} />
      <LegendExpandButton expanded={legendOpen} onClick={toggleLegend} />

      {chart?.({ expanded })}
      {
      currentTime ? 
      <TimeScrubberControls
        timeRange={timeRange}
        currentTime={currentTime}
        onTimeChange={onTimeChange}
        onTimeRangeChange={onTimeRangeChange}
        playing={playing}
        setPlaying={setPlaying}
        hideDatePicker={hideDatePicker}
        controls={
          <Tooltip title="Show maximum flood depth across the event">
          <Button variant="contained" size='small' onClick={() => onTimeChange(undefined)}>
            Show Peak Depth
          </Button>
          </Tooltip>
        }
      >
        
      </TimeScrubberControls>
       : 
      // null
      <Tooltip title="Replay the storm over time">
      <Button variant="contained" sx={{ borderRadius: '12px' }} onClick={() => onTimeChange(live ? toTime : fromTime)} startIcon={<PlayIcon />}>
        <span>Playback Data In Time</span>
      </Button>
      </Tooltip>
      }

      <Collapse in={legendOpenAuto} orientation="vertical" timeout="auto" sx={{ width: '100%' }} mountOnEnter unmountOnExit>
      {children}
      </Collapse>
      </Paper>
    </Box>
  );
}


const TimeSliderExpandIconButton = React.memo(({ expanded, onClick }: { expanded: boolean; onClick: () => void }) => {
  return (
    <Tooltip title={expanded ? "Collapse" : "Expand"} placement='top'>
    <IconButton
        size='small'
        // color='primary'
        variant="outlined"
        onClick={onClick}
        sx={{
          position: 'absolute',
          // top: 0,
          right: 0,
          // transform: expanded ? 'rotate(90deg) translate(-25%, -40%)' : 'rotate(90deg) translate(-25%, -40%)',
          // transform: expanded ? 'translate(30%, 20%)' : 'translate(30%, 20%)',
          // transform: expanded ? 'translate(40%, 40%) rotate(45deg)' : 'translate(40%, 40%) rotate(45deg) ',
          // transform: expanded ? {xs: 'translate(30%, 20%)', sm: 'translate(40%, 40%) rotate(45deg)'} : {xs: 'translate(30%, 20%)', sm: 'translate(40%, 40%) rotate(45deg)'},
          bottom: '100%',
          transform: 'translate(30%, 50%)',
          
          width: 24,
          height: 24,
          overflow: 'hidden',
          '& .MuiSvgIcon-root': {
            transition: 'transform 0.3s ease',
            transform: 'translate(15%, -15%) rotate(45deg)',
            // expanded ? 'rotate(45deg)' : 'rotate(45deg)',  
          },


          // transform: 'translate(0%, -100%)',
          // bgcolor: 'background.paper',
          '&:hover': {
            bgcolor: 'background.paper',
            // bgcolor: 'primary.main',
            // color: 'primary.contrastText',
          },
          // bgcolor: 'red',
          // p: 0.2,
          borderRadius: '4px',
          // borderRadius: expanded ? '12px 4px 0 0' : '4px 4px 0 0',
          // display: { xs: 'none', md: 'flex' },
        }}
      >
        {/* {expanded ? <CloseFullscreenIcon fontSize='small' /> : <OpenInFullIcon fontSize='small' />} */}
        {expanded ? <ExpandMoreIcon fontSize='small' /> : <ExpandLessIcon fontSize='small' />}
      </IconButton>
    </Tooltip>
  )
});

const LegendExpandButton = React.memo(({ expanded, onClick }: { expanded: boolean; onClick: () => void }) => {
  return (
    <Tooltip title={expanded ? "Hide legend" : "Show legend"}>
    <IconButton
        size='small'
        // color='primary'
        variant="outlined"
        onClick={onClick}
        sx={{
          position: 'absolute',
          bottom: 0,
          left: '50%',
          transform: expanded ? 'translate(-50%, 50%)' : 'translate(-50%, 50%)',
          // transform: 'translate(0%, -100%)',
          bgcolor: 'background.paper',
          '&:hover': {
            // bgcolor: 'background.paper',
            bgcolor: 'primary.main',
            color: 'primary.contrastText',
          },
          // bgcolor: 'red',
          p: 0.2,
          borderRadius: '4px',
          // borderRadius: expanded ? '12px 4px 0 0' : '4px 4px 0 0',
        }}
      >
        {expanded ? <ExpandLessIcon fontSize='small' /> : <ExpandMoreIcon fontSize='small' />}
      </IconButton>
    </Tooltip>
  )
});

